import React from 'react'
import AdmBookMovements from '../../components/AdminTabs/AdminBookMovements/AdmBookMovements'

const BookMovements = () => {
  return (
    <>
<AdmBookMovements />
    </>
  )
}

export default BookMovements